// import React from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import About from "./components/About";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
// import BackgroundImage from "./components/BackgroundImage";
// import FadeInSection from "./components/FadeInSection";

const App = () => {
  return (
    <div>
      <img
        src="/assets/img/artwork.png"
        alt="Transition bâtiment vers digital"
        className="parallax-bg"
        loading="lazy"
      />
      <Header />
      <Home />
      <section className="parallax-gap"></section>
      <About />
      <Projects />
      <Skills />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
